module.exports = __webpack_public_path__ + "img/clock.9bd833ee.svg";